import routes from "../../../engine/routes";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderMenuSider } from "../../../engine/AuthRoute/navigationHelper";
import { useSelector } from "react-redux";
import {
  renderStatusPrestation,
  renderStatusTag,
  roles,
} from "../../../utils/constants";
import { Spin } from "antd";
import { initPrestationSlice } from "../Slices/Prestation.slice";
import { userHasLevel } from "../../../engine/AuthRoute";

export const PrestationSlider = () => {
  const { id } = useParams();

  // const { init, clear, ready } = initPrestationSlice({ id });

  const { prestation, loading } = useSelector(state => state.prestation);

  const {
    institution,
    reference,
    status,
    subStatus,
    isFollow,
    control1,
    control2,
  } = prestation;

  const prestationDetailMenu = {
    title: `Prestation ${reference}`,
    root: routes.prestations,
    children: [
      routes.prestations(id).detail,
      routes.prestations(id).detailInterpretes,
      routes.prestations(id).detailInformations,
      routes.prestations(id).detailResume,
      routes.prestations(id).detailBilling,
    ],
  };

  return (
    <>
      <RenderMenuSider
        loading={loading}
        menu={prestationDetailMenu}
        extra={
          <div className={"specialWidthtags"}>

            {renderStatusPrestation(prestation, {
              showControls: userHasLevel({
                only: {
                  [roles.permanance]: "crud", //
                  [roles.admin]: "crud", //
                },
              }),
            })}
          </div>
        }
      />
    </>
  );
};
